import Address from '../models/IAddress';

export function isAddress(address: Partial<Address>): address is Address {
  return Boolean(address.address) && Boolean(address.city) && Boolean(address.state) && Boolean(address.zipcode);
}

export const getAddressFromGooglePlaceString = ({ place }: { place: google.maps.places.PlaceResult }): Address => {
  const { city, zipcode, state, streetNumber, route } =
    place?.address_components?.reduce(
      (acc, component) => {
        const componentType = component.types[0];

        switch (componentType) {
          case 'street_number': {
            acc.streetNumber = component.long_name;
            break;
          }

          case 'route': {
            acc.route += component.long_name;
            break;
          }

          case 'postal_code': {
            acc.zipcode = component.long_name;
            break;
          }
          case 'sublocality_level_1':
          case 'locality':
            acc.city = component.long_name;
            break;

          case 'administrative_area_level_1': {
            acc.state = component.short_name;
            break;
          }

          // Always US
          case 'country':
            break;
        }

        return acc;
      },
      { city: '', zipcode: '', state: '', streetNumber: '', route: '' }
    ) || {};

  let address;
  if (streetNumber && route) {
    address = [streetNumber, route].join(' ');
  } else {
    address = streetNumber || route;
  }

  return {
    city,
    address,
    zipcode,
    state,
  } as Address;
};

export const getGoogleStringFromAddress = ({ address, city, zipcode, state }: Address) => {
  return [address, city, state, zipcode].reduce((acc, value, index) => {
    if (value && index === 0) return value;
    else if (value) return `${acc}, ${value}`;

    return acc;
  }, '');
};
